import Vue from "vue";
import Vuex from "vuex";
import pathify from './pathify';
import {
  make
} from 'vuex-pathify';
import createPersistedState from 'vuex-persistedstate';

var state = {
  title: '',
  orders: null,
  user: null,
  lang: 1
};

var mutations = make.mutations(state);
Vue.use(Vuex);
var store = new Vuex.Store({
  state,
  mutations,
  plugins: [
    pathify.plugin, createPersistedState({
      key: 'naokiman',
      storage: window.sessionStorage
    })
  ],
});

global.store = store;
export default store;
